export default "__VITE_ASSET__D49xh_C4__"